<template>
  <div>
    <K-Loading :Loading="Loading" v-if="!datas"></K-Loading>
    <div v-else>
      <!-- 背景音乐 -->
      <K-Music :Music="datas.music"></K-Music>

      <header>
        <p class="logo"><img :src="datas.business.logo"></p>
        <p class="title">正品防伪查询中心</p>
      </header>

      <section class="mainFloat">
        <div class="mainBox" style="top: -24.8864px;">
          <div class="main">
            <div class="paddingBox boxOne">
              <div class="MHTitle">输入防伪密码</div>
              <div class="MHQueryBox">
                <div class="MHBd">
                  <input class="MHinput" maxlength="6" type="text" pattern="[0-9]*" v-model="vcode" @keyup.enter="CodeVerify" placeholder="请输入6位防伪密码">
                </div>
                <div class="MHQR" v-on:click="CodeVerify" style="display:none;">
                  <a class="showbtn">确定</a>
                </div>
                <div class="MHFt">
                  <div class="MHBtnbox">
                    <img src="../../static/images/Normal12/query.png">
                  </div>
                </div>
              </div>
            </div>
            <div class="paddingBox boxTwo" style="display:none;">
              <div class="MHTitle">所查询防伪码为</div>
              <div class="FWMBox">
                <a></a>
              </div>
            </div>

            <!-- 分割线 -->
            <div><img width="100%" src="../../static/images/Normal12/line.png"></div>

            <div class="paddingBox boxOne">
              <p class="YzHint">验证提示</p>
              <p class="YzTxt">请对照您所购买的产品上的防伪标识，依次输入防伪密码 验证结果分为以下三种情况：</p>
              <div>
                <div class="weui-cell no-before show-cell">
                  <div class="weui-cell__hd">
                    <img src="../../static/images/Normal12/icon_01.png" class="img-icon">
                  </div>
                  <div class="MHBd">
                    <p class="_title">正确查询</p>
                    <p class="_tip">即您所购买的商品为正牌产品</p>
                  </div>
                </div>
                <div class="weui-cell no-before show-cell">
                  <div class="weui-cell__hd">
                    <img src="../../static/images/Normal12/icon_02.png" class="img-icon">
                  </div>
                  <div class="MHBd">
                    <p class="_title">重复查询</p>
                    <p class="_tip">即同一验证码被多次查验，请确认首次查验是否由您本人所为，若非本人所为，则可能为假冒商品</p>
                  </div>
                </div>
                <div class="weui-cell no-before show-cell">
                  <div class="weui-cell__hd">
                    <img src="../../static/images/Normal12/icon_03.png" class="img-icon">
                  </div>
                  <div class="MHBd">
                    <p class="_title">错误查询</p>
                    <p class="_tip">即验证码不存在，您所购买的产品未经官方验证</p>
                  </div>
                </div>
              </div>
            </div>

            <div class="paddingBox boxTwo" style="display:none;">
              <p class="YzHint">验证结果</p>
              <div class="YzJg">
                <p class="YzJgImg"><img src="http://cha.fangwei.org/otinterface/html/fw/index.html"></p>
                <p class="YzJgTitle"></p>
                <p class="YzJgTxtx"></p>
                <p class="YzJgBtn"></p>
              </div>
            </div>

            <!--  -->
            <div class="paddingBox queryJg" style="display:none;">
              <div><img width="100%" src="../../static/images/Normal12/line.png"></div>
              <p class="YzHint" style="margin-top:4%;">验证结果</p>
              <p style="padding:2% 0;color:#777;font-size:0.9em;">历史查询记录为3次</p>
              <div class="small-box">
                <div class="weui-cell no-before show-cell">
                  <div class="weui-cell__hd">
                    <img src="../../static/images/Normal12/icon_01.png" class="img-icon">
                  </div>
                  <div class="weui-cell__bd">
                    <p class="_title">2018/4/3 15:37:42</p>
                    <p class="_tip">合法查询，网站：61.151.178.168</p>
                  </div>
                </div>
                <div class="weui-cell no-before show-cell">
                  <div class="weui-cell__hd">
                    <img src="../../static/images/Normal12/icon_01.png" class="img-icon">
                  </div>
                  <div class="weui-cell__bd">
                    <p class="_title">2018/4/3 15:37:54</p>
                    <p class="_tip">合法查询，网站：116.7.98.139</p>
                  </div>
                </div>
                <div class="weui-cell no-before show-cell">
                  <div class="weui-cell__hd">
                    <img src="../../static/images/Normal12/icon_07.png" class="img-icon">
                  </div>
                  <div class="weui-cell__bd">
                    <p class="_title">2018/4/3 15:40:59</p>
                    <p class="_tip">重复查询，网站：116.7.98.139</p>
                  </div>
                </div>
              </div>
            </div>

            <div><img width="148%" src="../../static/images/Normal12/bottomBg.jpg"></div>
          </div>
        </div>
      </section>

      <footer>
        <span>联系方式</span>
        <p v-if="datas.business.linkphone">电话：{{datas.business.linkphone}}</p>
        <p v-if="datas.business.customize_data" v-for="val in datas.business.customize_data" v-text="val.key+'：'+val.value"></p>
      </footer>


      <!-- 提示框 -->
      <section id="MaskedBlock" v-if="hintTxt">
        <i class="Masked"></i>
        <div class="ToolTip">
          <ul>
            <li>{{ datas.business.name }}</li>
            <li class="MaskedMain" v-text="hintTxt"></li>
            <li class="confirm" v-on:click="CloseTip">确定</li>
          </ul>
        </div>
      </section>

    </div>
  </div>
</template>

<script>
let self;
let checkTag = null;
import axios from 'axios'
import Swiper from 'swiper'
import Loading from '@/components/Loading.vue'
import Music from '@/components/Music.vue'
export default {
  name: 'Normal12',
  components: {
    'K-Loading': Loading,
    'K-Music': Music
  },
  data() {
    return {
      code: null,
      vcode: null,
      count: 2,
      datas: null,
      hintTxt: null,
      Loading: {
        type: 1,
        txt: "数据请求中..."
      },
      Music: {
        url: null,
        type: false
      }
    }
  },
  created() {
    self = this;
    document.querySelector('body').setAttribute('style', 'background: #f3f3f3;background-image: url(../../static/images/Normal12/back.jpg);background-repeat: no-repeat;background-size: 100%;');
   
    //判断是演示还是真实码标
    if (this.$route.query.type == "demo") {
      self.GetDemoDatas(this.$route.query.pid, this.$route.query.rid);  //获取演示模板信息
    } else {
      self.code = self.GetCode();
      self.GetDatas();  //获取码标信息
    }

  },
  methods: {
    GetDemoDatas(pid, rid) {
      axios.get(self.GetServerUrl(1) + "template_product/" + pid + "/" + rid)
        .then(function (response) {
          let datas = response.data.meta;
          let defaultDatas = JSON.parse(datas.default_basic.config_value);  //初始化默认信息

          if (datas.scan_count) {
            datas.scan_count = datas.scan_count;
          } else {
            datas.scan_count = 1;
          }
          datas.scan_first_time = "2017-10-31 12:12";
          datas.scan_first_address = "广东省深圳市";
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          } else {
            if (defaultDatas.ref) {
              datas.ref = JSON.parse(defaultDatas.ref);
            }
          }
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          if (datas.batch) {
            datas.batch = JSON.parse(datas.batch);
            datas.batch.qc = JSON.parse(datas.batch.qc);
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;

          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }

          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }

          //默认信息
          if (!datas.process) {
            datas.process = defaultDatas.process;
          }
          if (!datas.process_demo) {
            datas.process_demo = defaultDatas.process_demo;
          }
          if (!datas.dealer) {
            datas.dealer = defaultDatas.dealer;
          }

          self.datas = datas;
          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    GetDatas() {
      axios.get(self.GetServerUrl(1) + "query/" + self.code)
        .then(function (response) {
          let datas = response.data.meta.product_template;
          datas.scan_count = response.data.meta.scan_count;  //扫码次数
          datas.scan_first_time = response.data.meta.scan_first_time;  //扫码时间
          datas.scan_first_address = response.data.meta.scan_first_address;  //扫码地点
          datas.verify = response.data.meta.verify; //防伪码
          datas.plan_id = response.data.meta.plan_id; //生码批次

          //自定义防伪查询语句
          if (datas.first_antifake_msg) {
            self.msg = datas.first_antifake_msg;
          }

          //自定义属性
          if (response.data.meta.activation_a) {
            datas.attribute = JSON.parse(response.data.meta.activation_a);
          }

          //焦点图
          if (datas.focus) {
            datas.focus = JSON.parse(datas.focus);
          }
          //自定义栏目
          if (datas.ref) {
            datas.ref = JSON.parse(datas.ref);
          }
          //自定义菜单
          if (datas.menu) {
            datas.menu = JSON.parse(datas.menu);
          }
          //产品自定义属性
          if (datas.product.attribute) {
            datas.product.attribute = JSON.parse(datas.product.attribute);
          }
          //企业自定义属性
          if (datas.business.customize_data) {
            datas.business.customize_data = JSON.parse(datas.business.customize_data);
          }
          //批次信息
          if (datas.batch) {
            if (datas.batch.qc) {
              datas.batch.qc = JSON.parse(datas.batch.qc);
            }
          }
          if(datas.music && datas.music_is_show == 1){
            try {
              datas.music = JSON.parse(datas.music);
            } catch (error) {
              console.error(error)
            }
          }
          if (datas.video) {
            datas.video = JSON.parse(datas.video);
          }
          datas.activity_is_show = 1;
          self.datas = datas;

          self.$nextTick(function () {
            new Swiper('.banner', {
              autoplay: {
                delay: 3000
              },
              autoHeight: true, //高度随内容变化
              loop: true, //可选选项，开启循环
            })

            var win = $(window).width() / 22;
            if (win > 40) {
              win = 40;
            }
            $('.mainBox').css({
              top: -win * 1.5
            });
            $('body').css({
              fontSize: win
            });
            $('.MHinput').on('input', function() {
              checkTag = $('.MHinput').val();
              if (checkTag.length >= 6) {
                $('.MHQR').show(300);
              } else {
                $('.MHQR').hide(300);
              }
            });

            $('.YzJgBtn').click(function() {
              self.animateStyle(2)
            })

            $('.MHQR').click(function() {
              checkTag = $('.MHinput').val();
              if (!checkTag || checkTag.length < 6) {
                alert("防伪码不能为空或不能小于6位~");
              }
            })
          })

          // document.title = self.datas.business.name;  //设置页面标题
        }).catch(function (error) {
          console.log(error)
          self.Loading.type = 3;
          self.Loading.txt = self.ErrorHint(error);
        })
    },
    CodeVerify() {
      axios.get(self.GetServerUrl(1) + "queryVerify/" + self.code + "/" + self.vcode)
        .then(function (response) {
          let json = response.data;
          if (json.code == 200) {
            let datas = null;
            if (json.meta.query_count > 1) {
              datas = {
                // title: "此防伪码已失效，谨防假冒！",
                main: `This code has been verified! First time verified is on: ${json.meta.query_first_time} beware of counterfeit! 
您查询的防伪码已经被查询过,首次查询时间是${json.meta.query_first_time},谨防假冒!`,
                icon: "../../static/images/Normal12/icon_02.png"
              };
            } else {
              datas = {
                title: "你所查询的产品是正品！",
                main: `您好，您所查询的是${self.datas.business.name}生产销售的湘鹤品牌产品，此产品为${self.datas.product.name}，请放心使用!`,
                icon: "../../static/images/Normal12/icon_01.png"
              };
            }
            self.animateStyle(1, datas);
          } else {
            self.isShow = false;
          }
        }).catch(function (error) {
          self.animateStyle(1, {
            title: "对不起！没有相关记录！",
            main: `Sorry, This code does not exist, beware of counterfeit！你的防伪码不存在谨防假冒!`,
            icon: "../../static/images/Normal12/icon_03.png"
          });
          self.vcode = '';
        })
    },
    CloseTip() {
      self.hintTxt = null;
    },
    initVideo() {
      //初始化视频方法
      let myPlayer = this.$video(VideoBox, {
        controls: true,  //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
        autoplay: false,  //自动播放属性,muted:静音播放
        preload: "auto",  //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
      });
    },
    ViewMore(datas) {
      if (self.code) {
        this.$router.push({ path: "/ScanCodeRecord" }); // 模板路由跳转
      } else {
        alert("真实码标数据才能查看扫码记录！");
      }
    },
    inited(viewer) {
      self.$viewer = viewer
    },
    PreviewImgs() {
      self.$viewer.show();
      self.$viewer.update();
    },
    ClickMenu(data) {
      if (data.type != 2) {
        window.location.href = data.url;
      } else {
        this.$router.push({ path: "/qr?qr=" + data.qr });
      }
    },
    animateStyle(type, datas) {
				if (type == 1) {
					$('.boxOne').hide();
					$('.boxTwo').show();
					$('.YzJgTitle').text(datas.title);
					$('.YzJgTxtx').text(datas.main);
					$('.YzJgBtn').text('重新输入防伪码');
					$('.YzJgImg img').css({
						width: "10%"
					}).attr("src", datas.icon).animate({
						width: "22%"
					}, 400);
					for (var i = 0; i < 5; i++) {
						$('.FWMBox a').text(checkTag);
					}
				} else {
					$('.boxOne').show();
					$('.boxTwo,.MHQR').hide();
					$('.MHinput').val("");
					$('.YzJgTitle,.YzJgTxtx,.YzJgBtn').text("");
				}
			}
  }
}
</script>

<style scoped>
i{
	font-style:normal;
}
header{
	overflow: hidden;
}
body{
	font-size:16px;
}
img{
	display: block;
}
.logo{
	width:15%;
	margin:6.5% auto;
	display: table;
	overflow: hidden;
	border-radius: 1000px;
}
.logo img{
	width:100%;
}
.title{
	font-size:1.2em;
	text-align: center;
	color:#fff;
	padding-top:3%;
	padding-bottom:5%;
	letter-spacing:2px;
}
.mainFloat{
	position: relative;
}
.mainBox{
}
.main{
	margin:0 15px;
	padding-top:3%;
	border-radius: 5px;
	box-shadow: 0 2px 5px rgba(9,9,9,0.2);
	background-color: #FFFFFF;
	overflow: hidden;
	margin-bottom:4%;
	position: relative;
}
.paddingBox{
	padding:0 4%;
}
.MHTitle{
	color: #425582;
	font-weight: bold;
}
.MHQueryBox{
	border: 1px solid #eee;
	margin: 3% 0;
	border-radius:5px;
	padding:8px;
	display: -webkit-box;
}
.MHinput{
	font-size: 0.95em;
	display: block;
	line-height: inherit;
	height: 90%;
	width: 100%;
	border: 0;
	outline: 0;
	background-color: transparent;
	color: inherit;
}
.showbtn{
	font-size: 0.95em;
	color: #425582;
	padding-right: .6rem;
	cursor: pointer;
}

.MHBtnbox{
	padding-left: .6rem;
	border-left: 1px solid #eee;
}
.MHBtnbox img{
	padding-top:.1em;
	width: 1.35em;
}
.MHBd{
	-webkit-box-flex: 1;
	-webkit-flex: 1;
	flex: 1;
}
.MHFt{
    text-align: right;
    color: #999;
}
.YzHint{
	font-size:1s;
	color: #425582;
	font-weight: bold;
}
.YzTxt{
	font-size: .85em;
	color: #4c5365;
	padding: .1rem 0 .4rem;
}
.list-cell .img-icon {
    width: 1.3rem;
    display: block;
    margin-right: .4rem;
    position: relative;
    z-index: 2;
}
.weui-cell {
    padding: 4% 0;
	padding-left: 2%;
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
}
._title{
	color: #000;
	font-size:0.9em;
}
._tip{
	color: #a1a1a1;
	font-size:0.85em;
}
.img-icon{
	width: 1.8em;
	display: block;
	margin-right: 1em;
	position: relative;
	z-index: 2;
}

footer{
	background-color: #FFFFFF;
	padding:4%;
	position: relative;
}
footer span{
	display: block;
	font-size:1em;
	color: #425582;
	font-weight: bold;
	margin-bottom:2%;
}
footer p {
	font-size:0.85em;
	color:#444;
	letter-spacing:1px;
	line-height:150%;
	margin-top:1%;
}

.FWMBox{
	margin:3% 0;
	overflow: hidden;
}
.FWMBox a{
	float: left;
	display: block;
	width:96%;
	font-size:1.1em;
	padding:2%;
	background-image: url(../../static/images/Normal12/num-bg.png);
	background-repeat: no-repeat;
	background-size: 100% 100%;
	margin-right:2.5%;
	border-radius: 3px;
  text-align: center;
	overflow: hidden;
}

.YzJg{
	margin-top:3%;
	text-align: center;
}
.YzJg img{
	width:22%;
	margin:0 auto;
}
.YzJg p{
	font-size: 0.95em;
	margin-bottom:3%;
}
.YzJg p:last-child{
	font-size:0.85em;
	color:#666;
}
.queryJg{
	margin:3% 0;
}
.show-cell:first-child::after {
    height: 50%;
    top: 50%;
}
.show-cell::after {
    content: " ";
    position: absolute;
    top: 0;
    left: 6.5%;
    border-left: 1px dotted #eee;
    height: 100%;
}
.YzJgBtn{
	background-color: #007AFF;
	color:#FFFFFF !important;
	text-align: center;
	display: table;
	padding:8px 12px;
	margin:0 auto;
	border-radius: 4px;
	cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/view/Normal12.vue